import { Form, Formik } from 'formik'
import React from 'react'
import * as yup from 'yup'

import TextareaInput from '@/components/form/TextareaInput'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface Props {
  onSubmit: (amendmentRequest: string) => void
  onClose: () => void
  amendRequest?: string
}

interface FormValues {
  amendment: string
}

const FORM_FIELDS: Record<keyof FormValues, keyof FormValues> = {
  amendment: 'amendment',
}

const AmendESignatureModal: React.FC<Props> = ({
  onSubmit,
  onClose,
  amendRequest,
}) => {
  const initialValues: FormValues = {
    amendment: amendRequest || '',
  }

  const validationSchema = yup.object().shape({
    [FORM_FIELDS.amendment]: yup.string().trim().required(),
  })

  return (
    <Dialog open onHide={onClose}>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => onSubmit(values.amendment)}
      >
        <DialogContent>
          <Form>
            <DialogHeader>
              <DialogTitle>Amend eSignature letter</DialogTitle>
            </DialogHeader>

            <DialogBody>
              <TextareaInput
                label="Please explain how you want the letter to be amended:"
                name={FORM_FIELDS.amendment}
                autoFocus
                rows={5}
              />
            </DialogBody>

            <DialogFooter>
              <Button variant="outline-secondary" onClick={onClose}>
                Cancel
              </Button>

              <Button type="submit" variant="primary">
                Add amendment request
              </Button>
            </DialogFooter>
          </Form>
        </DialogContent>
      </Formik>
    </Dialog>
  )
}

export default AmendESignatureModal
